<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        Platform Tiktok
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div clas="text-right">
                    <base-input
                        v-model="SearchKeyword"
                        prepend-icon="fas fa-search"
                        :placeholder="$t('search')"
                    >
                    </base-input>

					<a href="https://auth-sandbox.tiktok-shops.com/oauth/authorize?app_key=66dakpkj62722&state=eid1">Connect Tiktok</a>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <h3 class="mb-0">Orders</h3>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        placeholder="From"
                                        class="form-control datepicker"
                                        v-model="startDate"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        class="form-control datepicker"
                                        v-model="endDate"
                                        placeholder="to"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-3">
                                <base-input>
                                    <el-select
                                        v-model="status"
                                        placeholder="Status"
                                    >
                                        <el-option
                                            v-for="option in OrderStatus"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>
                            <div class="col-md-2">
                                <base-button
                                    size="md"
                                    type="neutral"
                                    @click="handleSearchOrder()"
                                >
                                    Search
                                </base-button>
                            </div>
                        </div>
                    </template>
                    <div>
                        <div
                            class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
                        ></div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
                            <el-table-column
                                v-for="column in tableColumns"
                                :key="column.label"
                                v-bind="column"
                            >
                            </el-table-column>

                            <el-table-column
                                min-width="200px"
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="listData($index, row)"
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                        {{ $t("wms.inventory_in") }}
                                    </base-button>

                                    <base-button
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                        {{ $t("wms.inventory_out") }}
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap ">
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/TiktokclientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableData: "Tiktok/getOrders",
        }),
        tableColumns: function() {
            return [
                {
                    prop: "ProductName",
                    label: this.$t("wms.product"),
                    minWidth: 90,
                    sortable: true
                },

                {
                    prop: "StorageName",
                    label: this.$t("wms.storage"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "Balance",
                    label: this.$t("wms.balance"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "OverallAmount",
                    label: this.$t("wms.overall_amount"),
                    minWidth: 90,
                    sortable: true
                }
            ];
        }
    },
    data() {
        return {
            propsToSearch: ["Number", "Email"],
            selectedRows: [],
            SearchKeyword: "",
            showAddModal: false,
            showInOutModal: false,
            status: 0,
            startDate: "",
            endDate: "",
            md: {
                InventoryID: 0,
                ProductID: "-",
                StorageID: "-",
                Note: "",
                Quantity: "0",
                Cost: 0
            },
            inOut: {
                InventoryID: 0,
                ProductID: 0,
                StorageID: 0,
                Note: "",
                Quantity: 0,
                Cost: 0,
                Action: ""
            },
            rowEdit: {
                ID: 0,
                Number: ""
            },

            OrderStatus: [
                { ID: 0, Name: "All" },
                { ID: 100, Name: "Unpaid" },
                { ID: 111, Name: "AwaitingShipment" },
                { ID: 112, Name: "AwaitingCollection" },
                { ID: 114, Name: "PartiallyShipping" },
                { ID: 121, Name: "InTransit" },
                { ID: 122, Name: "Delivered" },
                { ID: 130, Name: "Completed" },
                { ID: 140, Name: "Cancelled" }
            ]
        };
    },
    mounted() {
    },
    methods: {
        ...mapActions({
            InventoryIn: "Inventory/InventoryIn",
            InventoryOut: "Inventory/InventoryOut",
            InventoryDelete: "Inventory/InventoryDelete",
            listData: "Tiktok/GetOrderList",
            getShippingDocument: "Tiktok/GetShippingDocument"
        }),

        handleSearchOrder() {

			if (this.startDate == "" || this.endDate == "") {
				swal.fire({
              title: "Invalid date",
              text: "",
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false,
            });
			return
			}

            let params = {
                time_from: this.startDate,
                time_to: this.endDate,
                status: this.status
            };
            console.log(params);

            this.listData(params);
        },

 

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
